import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
    DreamTeamCrossFunctionIdDisplay,
    DreamTeamFunctionDisplay,
    DreamTeamImprovementDisplay
} from '../../constants-types/StrategyConstants';

@Component({
    selector: 'ok-select',
    template: `
        <span
            class="select"
            [ngClass]="{ 'select-sm': selectSize === OkSelectSize.Small }"
        >
            <select
                class="form-control"
                name="language"
                [(ngModel)]="boundValue"
                [disabled]="disabled"
            >
                @if (placeholder) {
                    <option [ngValue]="null">
                        {{ placeholder }}
                    </option>
                }
                @if (displayOnlyPlaceholderValue) {
                    <option
                        [ngValue]="displayOnlyPlaceholderValue"
                        selected
                        disabled
                        hidden
                    >
                        {{ displayOnlyPlaceholderValue.display }}
                    </option>
                }
                @for (option of options; track option) {
                    <option [ngValue]="option">
                        <ng-template
                            [ngTemplateOutlet]="optionTemplate"
                            [ngTemplateOutletContext]="{
                                option: option
                            }"
                        >
                        </ng-template>
                    </option>
                }
            </select>
        </span>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: OkSelectComponent,
            multi: true
        }
    ],
    standalone: false
})
export class OkSelectComponent implements ControlValueAccessor {
    OkSelectSize = OkSelectSize;
    @ContentChild(TemplateRef, { static: false })
    optionTemplate: TemplateRef<any>;

    @Input()
    options: any[] = [];
    @Input()
    placeholder: string;
    @Input()
    displayOnlyPlaceholderValue:
        | DreamTeamFunctionDisplay
        | DreamTeamCrossFunctionIdDisplay
        | DreamTeamImprovementDisplay;
    // We should refactor this out and just make this functionality added via CSS
    @Input()
    selectSize?: OkSelectSize = OkSelectSize.Large;
    @Input()
    disabled = false;

    private _boundValue: any;
    propagateChange = (_: any) => {
        /* No change propagated */
    };

    get boundValue() {
        return this._boundValue;
    }

    set boundValue(val: any) {
        this._boundValue = val;
        this.propagateChange(this._boundValue);
    }

    /* Meet ControlValueAccessor Interface */
    // Do NOT propagate changes up here
    writeValue(value: any): void {
        this._boundValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }

    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    /** ***************************************/
}

export enum OkSelectSize {
    Small,
    Large
}
